import React from "react";

function KpiCard({ testId, label, count, hint, highlight }) {
  return (
    <div className={highlight ? "card kpi kpi-total" : "card kpi"} data-testid={testId}>
      <div className="meta-label">{label}</div>
      <div className="kpi-num" data-testid="kpi-count">
        {count}
      </div>
      <div className="kpi-hint">{hint}</div>
    </div>
  );
}

export default KpiCard;
